import React from "react";
import { useHistory } from "react-router-dom";
import { Modal, Text } from "@networkraildigitalfactory/components";
import { useObjectives, usePDP } from "../../../hooks/useAPI";
import { getPropsByAction, updateStatus, deleteDraft } from "./aysHelpers";
import useDisableScroll from "../../../hooks/useDisableScroll";

const AreYouSureModal = (props) => {
  const history = useHistory();
  const { selectedId, action, type, redirect, close, confirm } = props;
  const modalProps = getPropsByAction(action, selectedId, redirect, history, type);

  const [{ error: objectiveActionError }, executeObjectiveAction] = useObjectives(
    {
      url: selectedId,
      method: action === "Delete" ? "DELETE" : "PUT",
    },
    { manual: true }
  );

  const [{ error: pdpActionError }, executePdpAction] = usePDP(
    {
      url: selectedId,
      method: action === "Delete" ? "DELETE" : "PUT",
    },
    { manual: true }
  );

  const confirmParams = {
    isError: type === "PDP" ? pdpActionError : objectiveActionError,
    execute: type === "PDP" ? executePdpAction : executeObjectiveAction,
    modalProps,
    history,
    close,
    selectedId,
    type,
  };

  const onConfirm = async () => {
    if (action === "Delete") {
      await deleteDraft(confirmParams);
      confirm();
    } else {
      updateStatus(confirmParams);
    }
  };

  useDisableScroll(props.show);

  return (
    <Modal
      type="confirm"
      cancelText={modalProps.cancelText || "No"}
      cancelButtonColor="red"
      confirmText={modalProps.confirmText || "Yes"}
      confirmButtonColor={modalProps.confirmButtonColor || "blue"}
      show={props.show}
      onClose={props.close}
      onConfirm={onConfirm}
      style={{ maxWidth: "90%", width: "690px", top: "5vh", position: "fixed" }}
      focusOnClose={modalProps.focusOnClose}
    >
      <div>
        <Text
          wrapper="h1"
          type="header"
          style={{ marginBottom: "2rem", ineHeight: "140%", letterSpacing: "0.0015em" }}
        >
          Are you sure?
        </Text>
        <Text
          wrapper="p"
          type="body"
          color="#000000"
          style={{ ineHeight: "140%", letterSpacing: "0.0015em" }}
        >
          {modalProps.message}
        </Text>
        {modalProps.message2 && (
          <Text
            wrapper="p"
            type="body"
            color="#000000"
            style={{ ineHeight: "140%", letterSpacing: "0.0015em" }}
          >
            {modalProps.message2}
          </Text>
        )}
      </div>
    </Modal>
  );
};

export default AreYouSureModal;
